import Vue from 'vue'
import ACL from './ACL'

Vue.prototype.$acl = ACL
